import './header.scss';
import logo from '../../images/cotechie_logo.png';

export const Header = () => {
  return (
    <div className="headerContainer">
      <img className="logoWrapper" src={logo} />
    </div>
  );
}